import { render, staticRenderFns } from "./RelatorioCotasRegiao.vue?vue&type=template&id=7d8f974b"
import script from "./RelatorioCotasRegiao.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasRegiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports